import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "./Loader";
import Backdrop from "./Backdrop";
import WorkOffOutlinedIcon from "@mui/icons-material/WorkOffOutlined";
import DynamicDataGrid from "../components/dynamicDataGrid";
import { Typography, Box } from "@mui/material";

const columns = [
  { field: "id", headerName: "Job ID", filterable: false, width: 100 },
  {
    field: "title",
    headerName: "Job Name",
    width: 300,
    filterable: false,
    sortable: true,
  },
  {
    field: "short_description",
    headerName: "Current Status",
    filterable: false,
    sortable: true,
    width: 200,
  },
  {
    field: "date_created",
    headerName: "Date Added",
    filterable: false,
    sortable: true,
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ color: "#000", padding: "14px", fontSize: "13px" }}
      >
        {params.row.date_created
          ? new Date(params.row.date_created).toLocaleDateString("en-US")
          : "NA"}
      </Typography>
    ),
  },
];

const JobAssociated = () => {
  const [jobAssociatedData, setJobAssociatedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [queryOptions, setQueryOptions] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const nav = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    let payload = { pageSize: paginationModel.pageSize };
    if (queryOptions.sortModel && queryOptions.sortModel.length > 0) {
      payload.sortField = queryOptions?.sortModel[0].field;
      payload.sortBy = queryOptions?.sortModel[0].sort;
    }
    setLoading(true);

    axios
      .post(
        `/candidate-job-associated/${id}/page/${paginationModel.page + 1}`,
        payload,
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        setJobAssociatedData(response.data.message.data);
        setTotalCount(response.data.message.page);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [paginationModel, queryOptions]);

  const handleSortModelChange = React.useCallback((sortModel) => {
    setQueryOptions({ sortModel: [...sortModel] });
  }, []);

  const handleRowClick = (row) => {
    nav(`/jobOrders/${row.id}`, {
      state: { data: row, value: 0 },
    });
  };

  // if (loading) return <Loader />;

  // if (jobAssociatedData.length === 0)
  //   return (
  //     <Backdrop
  //       backDropText={"No Job Found"}
  //       backDropIcon={<WorkOffOutlinedIcon />}
  //     />
  //   );

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "auto" }}>
      {!loading && jobAssociatedData.length === 0 ? (
        <Backdrop
          backDropText={"No Job Found"}
          backDropIcon={<WorkOffOutlinedIcon />}
        />
      ) : (
        <DynamicDataGrid
          rows={jobAssociatedData}
          loading={loading} // ✅ yeh pehle se tha, bas ab kaam karega
          columns={columns}
          totalRows={totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          onRowSelection={handleRowClick}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
        />
      )}
    </Box>
  );
};

export default JobAssociated;
